module.exports = __webpack_public_path__ + "img/004-uranus.647f922a.svg";